'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    background: ', ';\n    min-height: ', ';\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    z-index: 1;\n'], ['\n    background: ', ';\n    min-height: ', ';\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    z-index: 1;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _colors = require('../../constants/colors');

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterComponent = _styledComponents2.default.div(_templateObject, function (_ref) {
    var context = _ref.context;
    return context && context.storefront && context.storefront.layoutFooterBackgroundColor ? context.storefront.layoutFooterBackgroundColor : (0, _getColor2.default)(_colors.Colors.Tertiary);
}, function (_ref2) {
    var mobile = _ref2.mobile;
    return mobile ? '80px' : '60px';
});

var FooterLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject2, function (_ref3) {
    var textColor = _ref3.textColor;
    return textColor && 'color: ' + (0, _getColor2.default)(textColor);
});
var FooterLink = (0, _styledComponents2.default)(_link2.default)(_templateObject2, function (_ref4) {
    var textColor = _ref4.textColor;
    return textColor && 'color: ' + (0, _getColor2.default)(textColor);
});

var Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
    }

    _createClass(Footer, [{
        key: 'render',
        value: function render() {
            var mobile = this.context.screen.isMobile;

            var copyrightComponent = _react2.default.createElement(FooterLabel, {
                textAlign: 'left',
                textColor: this.props.textColor,
                inverse: true,
                size: _sizes.Sizes.md,
                text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: this.props.context.storefront.footerCopyrightText || 'Footer.copyright',
                    values: {
                        year: new Date().getFullYear(),
                        brand: process.env.REACT_APP_Brand
                    }
                })
            });

            var footerText = _react2.default.createElement(FooterLabel, { textAlign: 'center',
                textColor: this.props.textColor,
                inverse: true,
                size: _sizes.Sizes.md,
                text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.centerText })
            });

            // Replace hardcoded text with FormattedMessage
            var legalComponent = _react2.default.createElement(FooterLink, {
                textAlign: 'left',
                textColor: this.props.textColor,
                inverse: true,
                secondaryStyle: true,
                text: _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Footer.privacyPolicy', defaultMessage: 'Privacy Policy' }),
                    !this.props.context.storefront.hiddenLegalStuff && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        ' | ',
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Footer.legalStuff', defaultMessage: 'Legal Stuff' })
                    )
                ),
                href: this.props.legalHref,
                newTab: true
            });

            var agentFooterLeftText = this.props.agentFooterLeftText && _react2.default.createElement(FooterLabel, { right: !mobile ? _sizes.Sizes.sm : _sizes.Sizes.none,
                textAlign: 'left',
                textColor: this.props.textColor,
                inverse: true,
                size: _sizes.Sizes.md,
                text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.agentFooterLeftText })
            });
            var agentFooterRightText = this.props.agentFooterRightText && _react2.default.createElement(FooterLabel, { textAlign: 'right',
                textColor: this.props.textColor,
                inverse: true,
                size: _sizes.Sizes.md,
                text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.agentFooterRightText })
            });

            return _react2.default.createElement(
                FooterComponent,
                { context: this.props.context,
                    mobile: mobile
                },
                (agentFooterLeftText || agentFooterRightText) && _react2.default.createElement(
                    _container2.default,
                    { left: mobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
                        right: mobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
                        top: mobile && _sizes.Sizes.sm,
                        bottom: mobile && _sizes.Sizes.md
                    },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            { nogutter: true },
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12,
                                    md: 12,
                                    nogutter: true
                                },
                                _react2.default.createElement(
                                    _container2.default,
                                    { horizontalAlignment: _alignments.Alignments.center,
                                        inline: !mobile
                                    },
                                    mobile ? _react2.default.createElement(
                                        _react2.default.Fragment,
                                        null,
                                        agentFooterLeftText,
                                        _react2.default.createElement(_column2.default, { xs: 1,
                                            md: 1
                                        }),
                                        agentFooterRightText
                                    ) : _react2.default.createElement(
                                        _react2.default.Fragment,
                                        null,
                                        agentFooterLeftText,
                                        agentFooterRightText
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _container2.default,
                    { left: mobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
                        right: mobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
                        top: mobile && _sizes.Sizes.sm,
                        bottom: mobile && _sizes.Sizes.md
                    },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            { nogutter: true },
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12,
                                    md: this.props.centerText ? 4 : 8,
                                    nogutter: true
                                },
                                this.props.context && this.props.context.storefront && this.props.context.storefront.displayCopyright === 'True' && _react2.default.createElement(
                                    _container2.default,
                                    { horizontalAlignment: mobile ? _alignments.Alignments.center : _alignments.Alignments.left },
                                    copyrightComponent
                                )
                            ),
                            this.props.centerText && _react2.default.createElement(
                                _column2.default,
                                { xs: 12,
                                    md: 4,
                                    nogutter: true
                                },
                                this.props.centerText && _react2.default.createElement(
                                    _container2.default,
                                    { horizontalAlignment: mobile ? _alignments.Alignments.center : _alignments.Alignments.left },
                                    footerText
                                )
                            ),
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12,
                                    md: 4,
                                    nogutter: true
                                },
                                _react2.default.createElement(
                                    _container2.default,
                                    { horizontalAlignment: mobile ? _alignments.Alignments.center : _alignments.Alignments.right },
                                    legalComponent
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Footer;
}(_react.Component);

Footer.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Footer;